import React, { useCallback, useEffect, useState } from 'react';
import { AdminProfiles } from 'helpers/Enum';
import Axios from 'axios';
import { useCompany, useProfile, useUser } from 'models';

export function useEffectRequest(
  __callback=()=>{}, __update=[]
){
  useEffect(()=>{
    let aux_token_cancel_request = Axios.CancelToken.source();
    let id = setTimeout(()=>{
      __callback(aux_token_cancel_request.token);
    },300);
    return ()=>{
      clearTimeout(id);
      aux_token_cancel_request.cancel('');
    }
  },__update);
}

export function useStateHash(start = ""){
  const [ __get, __set ] = useState(()=>{
    window.location.hash = start
    return start
  });

  const set = useCallback((v)=>{
    window.location.hash = v
  },[]);

  useEffect(()=>{
    window.onhashchange = ()=>{
      let hash = window.location.hash;
      if(hash){
        __set(decodeURI(hash).replace("#",""))
      } else {
        __set("");
      }
    };
    return ()=>{
      window.onhashchange = null;
    }
  },[]);

  return [__get, set]
}

export function createElementByString(str){
  let element = document.createElement("div");
  element.innerHTML = str;
  return element.children[0];
}

function isEmail(text) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(text);
}

export function convertTextToHtml(text = ""){
  return text.split('\n').map(line=>{
    let value = line.trim();
    if(!!!value){
      return "<br/>";
    }

    value = value.split(" ").map((word)=>{
      if(isEmail(word)){
        return `<a href="mailto:${word}">${word}</a>`
      }

      return word;
    }).join(" ");

    return `<div>${value}</div>`;
  }).join("");
}

export function fiscalYearsList(company, user, profile){
  if (!!company && !!company.adhesion) {
    if(company.adhesion.length > 0){
      if (AdminProfiles.includes(profile.id)) {
        return [...company.adhesion].map(item => item.fiscal_year);
      }
      return [...company.adhesion].map(item => item.fiscal_year).filter(year => year.block != 1)
    }
  }
  if (AdminProfiles.includes(profile.id)) {
    return [...user.fiscal_years].reverse()
  }
  return [...user.fiscal_years].filter(year => year.block != 1).reverse()
}

export function useFiscalYearsList(){
  const user = useUser();
  const profile = useProfile()
  const { company } = useCompany()

  const [fiscalYears] = useState(()=>{
    return fiscalYearsList(company, user, profile)
  })

  return fiscalYears;
}

export function getNameByYear(fiscalYear){
  if(fiscalYear.types){
    let types = fiscalYear.types.filter(a=>a.type_id != 2);
    if(types.length > 0){
      return types[0].name;
    }
  }

  return "Dashboard";
}